import { createElement, useContext, FC } from 'react';
import { ScrollContainer } from 'react-router-scroll-4';
import Screen from '../screen/SignedInScreen';
import User from '../../entity/User';
import { context as StateContext } from '../context/state';

type Props = {
  user: User | null;
  className?: string;
};

const SignedInScreen: FC<Props> = ({ className, user }) => {
  const state = useContext(StateContext);

  return !state.fatalError && state.authentication.signedInUser !== null ? (
    <ScrollContainer scrollKey="signed_in_screen">
      <Screen className={className} user={user} />
    </ScrollContainer>
  ) : null;
};

export default SignedInScreen;
